import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import ExplainedLogo from "./explained-logo.svg";
import ScmpFilmsLogo from "./scmp-films-logo.svg";
import SeriesLogo from "./series-logo.svg";
import SpotlightLogo from "./spotlight-logo.svg";
import TalkingPostLogo from "./talking-post-logo.svg";

export const Background = styled.div`
  inline-size: 100vw;
  margin-inline-start: -20px;

  background-color: #30343c;

  ${theme.breakpoints.up("tablet")} {
    margin-inline-start: -32px;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-inline-start: -36px;
  }

  ${theme.breakpoints.up("xLargeDesktop")} {
    margin-inline-start: calc(50% - 50vw);
  }
`;

export const MainContainer = styled.div`
  display: flex;
  justify-content: center;

  inline-size: 100%;
`;

export const StyledExplainedLogo = styled(ExplainedLogo)``;

export const StyledSeriesLogo = styled(SeriesLogo)``;

export const StyledSpotlightLogo = styled(SpotlightLogo)`
  inline-size: 248px;
  block-size: auto;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 100%;
  }
`;

export const StyledTalkingPostLogo = styled(TalkingPostLogo)``;

export const StyledScmpFilmsLogo = styled(ScmpFilmsLogo)``;

export const InfiniteScrollPlaceholder = styled.div`
  block-size: 1px;
`;

export const ContentLinksContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 28px 32px;
  justify-content: center;
  justify-items: center;

  max-inline-size: 1208px;
  margin-inline: auto;
  padding-block: 28px;
  padding-inline: 20px;

  ${theme.breakpoints.up("tablet")} {
    gap: 48px 32px;

    padding-block: 40px;
  }
`;
